import React, { useContext, useState } from "react";
import axios from "axios";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import AuthContext from "../../contexts/Islogin";

const VerifyDeposit = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { url } = useContext(AuthContext);

  const handleSubmit = async () => {
    setError(null);
    setResponse(null);
    setLoading(true);

    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${url}api/v1/transactions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(res.data);
      setResponse(res.data);
    } catch (err) {
      console.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{ p: 3, width: "80%", paddingX: "2%", mx: "auto", mt: 5 }}
    >
      <Typography
        variant="h6"
        gutterBottom
        dir="rtl"
        sx={{ textAlign: "right" }}
      >
        تراکنش ها
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            "دریافت تراکنش ها"
          )}
        </Button>

        {response?.wallet && (
  <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
    <Typography variant="subtitle1" gutterBottom dir="rtl" sx={{ textAlign: "right" }}>
      اطلاعات کیف پول
    </Typography>
    <Box display="flex" flexDirection="column" gap={1} dir="rtl">
      <Typography><strong>آدرس کیف پول:</strong> {response.wallet.wallet_address}</Typography>
      <Typography><strong>موجودی:</strong> {parseFloat(response.wallet.balance).toFixed(8)}</Typography>
    </Box>
  </Paper>
)}


        {response?.transactions?.length > 0 && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">شناسه تراکنش</TableCell>

                  <TableCell align="center">مقدار</TableCell>
                  <TableCell align="center">وضعیت</TableCell>
                  <TableCell align="center">مقدار قبلی</TableCell>
                  <TableCell align="center">مقدار بعدی</TableCell>
                  <TableCell align="center">ادرس مبدا</TableCell>
                  <TableCell align="center">ادرس مقصد</TableCell>
                  <TableCell align="center">تاریخ</TableCell>
                  <TableCell align="center">نوع</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {response.transactions.map((tx, index) => (
                  <TableRow
                    key={index}
                    style={{
                      backgroundColor:
                        tx.type === "withdraw"
                          ? 
                          "rgba(244, 67, 54, 0.1)" // سبز کم‌رنگ
                          : tx.type === "deposit"
                          ?"rgba(76, 175, 80, 0.1)"  // قرمز کم‌رنگ
                          : "transparent",
                    }}
                  >
                    <TableCell align="center">
                      {tx.tx_id ? tx.tx_id : "-"}
                    </TableCell>
                    <TableCell align="center">{tx.amount}</TableCell>
                    <TableCell align="center">
                      {tx.status ? tx.status : "-"}
                    </TableCell>
                    <TableCell align="center">{tx.balance_before}</TableCell>
                    <TableCell align="center">{tx.balance_after}</TableCell>
                    <TableCell align="center">
                      {tx.from_address ? tx.from_address : " - "}
                    </TableCell>
                    <TableCell align="center">
                      {tx.to_address ? tx.to_address : " - "}
                    </TableCell>
                    <TableCell align="center">
                      {new Date(tx.created_at).toLocaleString("fa-IR")}
                    </TableCell>
                    <TableCell align="center">{tx.type}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {error && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <Alert severity="error">خطا</Alert>
            <pre
              style={{
                backgroundColor: "#fff0f0",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(error, null, 2)}
            </pre>
          </Paper>
        )}
      </Box>
    </Paper>
  );
};

export default VerifyDeposit;
